import styled from "styled-components";

/** Same content column as Projects — use for EXPERIENCE, TECH SKILL, etc. */
export const SectionInner = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 0 auto;
  box-sizing: border-box;
`;
